import React from "react";

const CustomDivider = ({ className }: { className?: string }) => {
  return <div className={`divider m-0 ${className}`}></div>;
};

export default CustomDivider;
